import React from 'react';
import Planos from './Planos';
import EfetuarPagamento from './EfetuarPagamento';
import './pagamento.css';
import './styles-form-confirmacao.css';
import { PLANOS_BOX } from '../../config/Config';
import ConfirmacaoCartao from './ConfirmacaoCartao';
import ConfirmacaoBoleto from './ConfirmacaoBoleto';
import Dialog from '../../components/alert/Dialog';
import Requisitions from '../../utils/requisitions/Requisitions';
import RequisitionsLoader from '../../utils/requisitions/RequisitionsLoader';
import STRINGS from './../../data/language/language';

const URL_BOLETO_PROD = 'https://stc.pagseguro.uol.com.br/pagseguro/api/v2/checkout/pagseguro.directpayment.js';
const URL_BOLETO_SANDBOX = 'https://stc.sandbox.pagseguro.uol.com.br/pagseguro/api/v2/checkout/pagseguro.directpayment.js';

export default class Pagamento extends React.Component{
  constructor(props){
    super(props);

    this.state = {
      boxAtivo: PLANOS_BOX.planos,
      strings:STRINGS[window.LANGUAGE]
    };

    this.changeBox = this.changeBox.bind(this);
    this.showPlanos = this.showPlanos.bind(this);
    this.successBuying = this.successBuying.bind(this);
  }

  componentDidMount(){
    if (!document.getElementById("pagseguro-js")) {
      this.createScriptPagseguro();
    }else{
      RequisitionsLoader.createLoader();
      this.initPagSeguro();
    }
  }

  getBox(){
    let box;

    switch(this.state.boxAtivo){
      case PLANOS_BOX.planos:
        box =
          <Planos
            data={this.props.data}
            changeBox={this.changeBox}
          />;
        break;
      case PLANOS_BOX.pagamento:
        box =
          <EfetuarPagamento
            dados={this.state.planoAtivo}
            senderHash={this.state.senderHash}
            changeBox={this.showPlanos}
            successBuying={this.successBuying}
          />;
        break;
      case PLANOS_BOX.pagamentoCardSuccess:
        box =
          <ConfirmacaoCartao history={this.props.history} />;
        break;
      case PLANOS_BOX.pagamentoBoletoSuccess:
        box =
          <ConfirmacaoBoleto history={this.props.history} link={this.state.linkBoleto} />;
        break;
    }

    return box;
  }

  //insere o script do pagseguro na página
  createScriptPagseguro(){
    setTimeout(() => {
      RequisitionsLoader.createLoader();
    },400);

    let url = (window.location.href.indexOf("app.foco90.com.br") > -1) ? URL_BOLETO_PROD : URL_BOLETO_SANDBOX;

    const self = this;
    var s = document.createElement( 'script' );
    s.setAttribute( 'src', url );
    s.setAttribute( 'id', 'pagseguro-js' );
    s.onload= () => {
      self.initPagSeguro();
    };
    document.body.appendChild( s );
  }

  //inicia o pagseguro
  initPagSeguro() {
    const self = this;
    window.PagSeguroDirectPayment.setSessionId(this.props.ps_session);

      window.PagSeguroDirectPayment.onSenderHashReady(function (response)
      {
          if (response.status == 'error')
          {
              const strings = STRINGS[window.LANGUAGE];
              const msg = {
                title: strings.atencao,
                text: strings.ErroPagseguro
              };
              Dialog.create(msg);
              return false;
          }

          self.setState({
            senderHash : response.senderHash
          });
          RequisitionsLoader.removeLoader();

      });
  }

  successBuying(args) {

    let data = { boxAtivo: args.type };

    if(PLANOS_BOX.pagamentoBoletoSuccess === args.type){
      data.linkBoleto = args.link;
    }

    this.setState(data);
  }

  changeBox(args){
    this.setState({
      planoAtivo: args,
      boxAtivo: PLANOS_BOX.pagamento
    });
  }

  showPlanos(){
    this.setState({
      planoAtivo: null,
      boxAtivo: PLANOS_BOX.planos
    });
  }

  render(){
    const box = this.getBox();
    return(
      <div>
        {box}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/pagamento/Pagamento.js